
/*
import { Component, OnInit, Input } from '@angular/core';
import { UserService } from '../user.service';
import { User } from '../models/users.model';

import { Router } from '@angular/router';

import { ChartsComponent } from '../charts/charts.component';

*/


import {
  Component,
  OnInit,
  ElementRef,
  ChangeDetectorRef,
  Input
} from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from '../user.service';

import { User } from '../models/users.model';

//import { Chart } from 'chart.js';
// import { ChartsComponent } from '../charts/charts.component';



@Component({
  selector: 'lab-pane',
  templateUrl: './lab-pane.component.html'
})

/*
interface TeamsScope extends ng.IScope {
  teams: string[]
}
*/
export class LabPaneComponent implements OnInit {
  /*
	this.fn_load = function () {
		console.log("page load");
	};
	*/

  @Input() page: number;

  user: User;
  accessKey = '';
  secretAccessKey = '';
  labState = {};
  lab2_sec_group = '';

  toggle0 = false;
  toggle1 = false;
  toggle2 = false;
  toggle3 = false;
  toggle4 = false;
  toggle5 = false;
  toggle6 = false;
  toggle7 = false;
  toggle8 = false;
  toggle9 = false;
  toggle10 = false;
  toggle11 = false;
  toggle12 = false;
  toggle13 = false;
  toggle14 = false;
  toggle15 = false;
  toggle16 = false;
  toggle17 = false;

  //constructor(private dataAccessService: app.common.DataAccessService, $http: ng.IHttpService, $scope: TeamsScope, userService: UserService) { }

  /*
	public textBinding:string;
	public dataBinding:number;
	public functionBinding:() => any;

	constructor(private userService: UserService) {

		this.textBinding = '';
		this.dataBinding = 0;
	}

	add():void {
		this.functionBinding();
	}

	*/



constructor(
  private userService: UserService,
  private router: Router,
  private elementRef: ElementRef,
  private changeDetectorRef: ChangeDetectorRef,
) {}

  //constructor(private userService: UserService) {}

  ngOnInit() {
    //alert('THE INIT IN THE LAB PROGRESS');

    /*
	this.fetchEvent().then(() =>
	console.log(this.ev)); // Now has value;

	*/
  }


  aws_op_dashboard() {
    this.router.navigate(['/dashboard']);
  }

  /*
  fn_load() {
	 console.log("page load");
  }
*/
  //$scope.firstname = "John";

  nextLab() {
    this.page += 1;
  }

  previousLab() {
    if (this.page >= 0) {
      this.page -= 1;
    }
  }

  toggle(num) {
    console.log('TOGGLE"');
    console.log(num);
    switch (parseInt(num)) {
      case 0:
        console.log(num, this.toggle0);
        this.toggle0 = !this.toggle0;
        break;
      case 1:
        this.toggle1 = !this.toggle1;
        break;
      case 2:
        this.toggle2 = !this.toggle2;
        break;
      case 3:
        this.toggle3 = !this.toggle3;
        break;
      case 4:
        this.toggle4 = !this.toggle4;
        break;
      case 5:
        this.toggle5 = !this.toggle5;
        break;
      case 6:
        this.toggle6 = !this.toggle6;
        break;
      case 7:
        this.toggle7 = !this.toggle7;
        break;
      case 8:
        this.toggle8 = !this.toggle8;
        break;
      case 9:
        this.toggle9 = !this.toggle9;
        break;
      case 10:
        this.toggle10 = !this.toggle10;
        break;
      case 11:
        this.toggle11 = !this.toggle11;
        break;
      case 12:
        this.toggle12 = !this.toggle12;
        break;
      case 13:
        this.toggle13 = !this.toggle13;
        break;
      case 14:
        this.toggle14 = !this.toggle14;
        break;
      case 15:
        this.toggle15 = !this.toggle15;
        break;
      case 16:
        this.toggle16 = !this.toggle16;
        break;
      case 17:
        this.toggle17 = !this.toggle17;
        break;
    }
  }

  sendKey() {
    if (this.accessKey.length == 0 || this.secretAccessKey.length == 0) {
      alert('Missing valid access key and secret access key.');
      return;
    }

    this.userService.user.secretAccessKey = this.secretAccessKey;
    this.userService.user.accessKey = this.accessKey;

    this.userService.createUser(this.userService.user).subscribe(
      res => {
        let pass = res['checks']['overallPass'];
        this.labState['lab1'] = pass;
        if (pass) {
          alert('You passed!!');
        } else {
          alert('You failed lab 1. Please try again.');
        }
      },
      err => {
        console.log('Error occured', err);
      },
    );
  }

  verifyLab2() {
    if (this.lab2_sec_group.length == 0) {
      alert('Missing security group');
    }

    this.userService.verifyLab2(this.lab2_sec_group).subscribe(
      res => {
        let pass = res['checks']['overallPass'];
        this.labState['lab1'] = pass;
        if (pass) {
          alert('You passed!!');
        } else {
          alert('You failed lab 2. Please try again.');
        }
      },
      err => {
        console.log('Error occured', err);
      },
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/lab-pane/lab-pane.component.ts